import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'eci-product-img-upload',
  templateUrl: './product-img-upload.component.html',
  styleUrls: ['./product-img-upload.component.scss']
})
export class ProductImgUpload {
  header: string = "Please confirm";
  data: any;
  leftBtnText: string = 'Cancel';
  rightBtnText: string = 'Save';
  showRightBtn: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ProductImgUpload>,
  ) {
  }
}
